<template>
    <section>
        <div class="spacing">

            <h2>Creating compelling use cases</h2>
            <h3>Using open APIs to integrate services with 5G voice and even third-party elements allows CSPs to offer exciting new capabilities for consumers, enterprises and public services.</h3>

            <div class="box-holder">
                <div @click="goToStep(5, 2)">Enterprise voice services</div>
                <div @click="goToStep(5, 3)">5G voice and video bundled with 5G Fixed Wireless Access</div>
                <div @click="goToStep(5, 4)">Speech recognition and keyword detection-based services</div>
                <div @click="goToStep(5, 5)">Personalized voice activated IoT services</div>
                <div @click="goToStep(5, 6)">Intelligent voice and video services – managing multiple personas with fixed mobile convergence</div>
                <div @click="goToStep(5, 7)">Emergency voice communication</div>
                <div @click="goToStep(5, 8)">Immersive voice for more engaging augmented and virtual reality gaming</div>
            </div>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
        methods: {
            goToStep(chapter, step) {
                this.$emit('goToStepCalled', chapter, step);
            }
        }
    }

</script>

<style lang="scss" scoped>

    @import '~@/assets/scss/_variables.scss';

    .box-holder {
        display: flex;
        flex-wrap: wrap;
        height: 520px;
        margin: 60px -20px -40px;

        > div {
            background-color: $color-blue;
            width: calc(33.333333% - 40px);
            margin: 0 20px 40px;
            display: flex;
            position: relative;
            padding: 30px;
            color: white;
            cursor: pointer;

            &:after {
                background: url(~@/assets/images/layout/icon-arrow-right.png);
                position: absolute;
                right: 20px;
                bottom: 20px;
                width: 18px;
                height: 17px;
                content: '';
            }

            &:hover {
                background-color: darken($color-blue, 4);
            }
        }
    }

</style>